import TransactionFeed from './TransactionFeed';
import { FeedUI } from './TransactionFeed/types';

// In the future this repo might be used to display other
// stuff that just the transaction feed, so keeping the App
// component open for handling that.
const App = ({ uiData }: { uiData?: FeedUI }) => {
    return <TransactionFeed uiData={uiData} />;
};

export default App;
